import React, { useEffect, useState } from "react";

interface Props {
  setSelectedFile: (file: File | undefined) => void;
  selectedFileView?: boolean;
  inputId: string;
  /** Merged with the default dropzone styles (e.g. rounded-2xl border-dashed) */
  className?: string;
}

const ImageUploader = ({
  setSelectedFile,
  selectedFileView,
  inputId,
  className = "",
}: Props) => {
  const [preview, setPreview] = useState<string | undefined>(undefined);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    } else {
      setSelectedFile(undefined);
      setPreview(undefined);
    }
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    const file = event.dataTransfer.files && event.dataTransfer.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  useEffect(() => {
    setPreview(undefined);
  }, [selectedFileView]);

  return (
    <>
      <div
        className={`flex cursor-pointer flex-col items-center justify-center border border-gray-200 bg-white/80 transition hover:border-[#205f43]/35 hover:bg-[#f8faf9] ${className}`}
        onClick={() => document.getElementById(inputId)?.click()}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            document.getElementById(inputId)?.click();
          }
        }}
        role="button"
        tabIndex={0}
        aria-label="Subir foto de la factura"
      >
        {preview ? (
          <img
            src={preview}
            alt="Vista previa del comprobante"
            className="mx-auto h-40 max-h-[min(50vh,220px)] w-full max-w-sm object-contain p-2"
          />
        ) : (
          <p className="p-6 text-center text-sm text-slate-600 sm:text-base">
            Arrastrá o tocá para elegir un archivo
          </p>
        )}
        <input
          type="file"
          id={inputId}
          name="fileInput"
          className="hidden"
          accept="image/png, image/jpeg, image/webp, .pdf"
          onChange={handleFileChange}
        />
      </div>
    </>
  );
};

export default ImageUploader;
